export var HumanTaskState;
(function (HumanTaskState) {
    HumanTaskState["Pending"] = "Pending";
    HumanTaskState["Claimed"] = "Claimed";
    HumanTaskState["Expired"] = "Expired";
    HumanTaskState["Complete"] = "Complete";
})(HumanTaskState || (HumanTaskState = {}));
//# sourceMappingURL=state.js.map